// extracted by mini-css-extract-plugin
export default {"Comments":"styles_Comments__ATpnf"};